import React from "react";
import { useState,useEffect } from "react";
import { Menu,Dash } from "../menu";
import Iconos from "../iconos/iconos";
import { getValue } from '@syncfusion/ej2-base';
import { GridComponent, ColumnsDirective, ColumnDirective, Filter, Page, Sort, Resize, Inject } from '@syncfusion/ej2-react-grids';
import './poolreferencias.css';
import './../../css/bootstrap.min.css';
import './../../css/material3.css'
import { URL, URLSOCKET, GETDOCUMENTBYID, SAVEUPDATEDOCUMENT, GETREFERENCEBYID, GETREFERENCESBYUSER, SAVEUPDATEREFERENCE} from "../paths";
import { ToastContainer, } from 'react-toastify';
import { useModal } from '../../hooks/useModal';
import Modal from "../modal";
import Loader from "../loader/loader"; 
import { Mensaje } from "../Message/message";
import { getUserID, getUserName, getUserEntityIsEmployee,getIntUserEntityTypeId, getintUserEntityId } from "../datainfo/dto";
import { fetchData } from "../../hooks/fetch/const_fetch";
import { ValidaItemMenu,ValidaIsModal,validSesion } from "../datainfo/dto";
import CerrarSesion from "../datainfo/del_dto";
import MostrarPdf from "../mostrar_pdf/MostrarPdf";
import UploadFile from "../referencia/uploadfile";
//import {ModalRechazarPdf}
import ModalRechazarPdf from "../modales/ModalRechazarPdf";  
import io from 'socket.io-client';
import Cookies  from 'universal-cookie'; 

import { L10n } from '@syncfusion/ej2-base';
import deDELocalization from '../es-ES.json'
L10n.load(deDELocalization);

const PoolReferencias = () => { 
   
    const cookies  = new Cookies();
    const [pdfData, setPdfData] = useState();
    const [buscar,setBuscar] = useState("");
    const [validabuscar,setValidaBuscar] = useState("");
    const [dtodocuments,setDtoDocuments] = useState([]);
     
    const [isOpenEliminar, OpenEliminar, closeEliminar] = useModal(false);
    const [isOpenSubirDocumento, OpenSubirDocumento, closeSubir] = useModal(false);
    const [isOpenMostrarPfd, OpenMostrarPfd, closeMostrarPfd] = useModal(false);
    const [isOpenRechazarPdf, OpenRechazarPdf, closeRechazarPdf] = useModal(false);

    const [isLoading, setIsLoading] = useState(false);
    
    const [agrgandodocumento,setAgregandoDocumentos] = useState(false); 

    const [pbip, setPbip] = useState();
    const [muellaje, setMuellaje] = useState();
    const [buque, setBuque] = useState();
    const [solicitado_por, setSolicitadoPor] = useState();
     
    const [referenciaid, setReferenciaId] = useState();
    const [strDocumentTypeDescription, setStrDocumentTypeDescription] = useState();
    const [intmode,setIntMode] = useState();
    
    const [referencia,setReferencia]= useState();
    const [strreferencia,setStrReferencia]= useState("");
    
    const [estatus,setEstatus]= useState();
    const [modo,setModo]= useState("");
 
    let [tabIndex, setTabIndex] = useState(0);
    const [primera, setPrimera] = useState(true);
 
    useEffect(()=>{
        if(primera){
            ConsultarDocumentosUsuario();
            setPrimera(false);
        } 

        const socket = io(URLSOCKET, {autoConnect:true,transports: [ 'websocket' ]});
        // Puedes agregar lógica adicional aquí, como suscribirte a eventos
        socket.on("connect", () => {
          // console.log("Socket conectado ID: "+socket.id);
        });
 
        if(getUserEntityIsEmployee() === 1){
            socket.on("ref", (msg) => { 
               // console.log(msg); 
                if(msg.code !== 0){
                    return;
                }else if(msg.intMode === 1 || msg.intMode === 3 || msg.intMode === 7){
                    ConsultarDocumentosUsuario(false);
                }
                else{ 
                    ActualizarLista(msg.intMode,msg.ref); 
                }
                
            });
        }else{               
            socket.on("ref_"+getIntUserEntityTypeId() +"_"+ getintUserEntityId(), (msg) => { 
                //alert(msg.intMode)
               // console.log(msg);
                if(msg.code !== 0){
                    return;
                }else if(msg.intMode === 1 || msg.intMode === 3 || msg.intMode === 7){
                    ConsultarDocumentosUsuario(false);
                }
                else{ 
                    ActualizarLista(msg.intMode,msg.ref); 
                }
            }); 
        } 
        //Cierra la conexión del socket cuando el componente se desmonta
        return () => {
          socket.disconnect();
         // console.log("Socket desconetado.")
        }; 
     
    }, []);
    
    if(!(validSesion())){ 
        CerrarSesion();
        window.location.assign('/login');
        return;
    } 

    const ActualizarLista = (intMode,objeto) => { 
        try {
        
            setDtoDocuments((DtoDocuments) => {
                // encuentra y estatus es cero la quite
                // Usar el estado anterior para evitar problemas de actualización 
                return DtoDocuments.map((elemento) =>
                        elemento.intCusDocId === objeto.intCusDocId? 
                            { ...elemento,  
                                strCusDocLastModifiedBy :objeto.strCusDocLastModifiedBy, 
                                strCusDocLastModifiedBy:objeto.strCusDocLastModifiedBy, 
                                strStatus:objeto.strStatus,
                                strReason:objeto.strReason
                            }
                            : elemento
                    ); 
                });  
         
            /*//console.log(dtodocuments);
            const index = dtodocuments.findIndex((item)=>item.intCusDocId == objeto.intCusDocId);
            //alert(index);
            if(index < 0 ){
                ConsultarDocumentosUsuario();
            }else{
                setDtoDocuments((DtoDocuments) => {
                    // encuentra y estatus es cero la quite
                    // Usar el estado anterior para evitar problemas de actualización 
                    return DtoDocuments.map((elemento) =>
                            elemento.intCusDocId === objeto.intCusDocId? 
                                { ...elemento,  
                                    strCusDocLastModifiedBy :objeto.strCusDocLastModifiedBy, 
                                    strCusDocLastModifiedBy:objeto.strCusDocLastModifiedBy, 
                                    strStatus:objeto.strStatus,
                                    strReason:objeto.strReason
                                }
                                : elemento
                        ); 
                    });  
            }*/
        } catch (error) {
           // console.log("Error al actualizar el listado, Error: "+error.Mensaje());
        }
       
        
        /*switch (intMode) {
            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
          }*/
        /*
        //console.log(dtodocuments);
        const index = dtodocuments.findIndex((item)=>item.intCusDocId == objeto.intCusDocId);
        //alert(index);
        if(index < 0 ){
            ConsultarDocumentosUsuario();
        }else if(intMode === 0){
            ConsultarDocumentosUsuario();
        }else{
            setDtoDocuments((DtoDocuments) => {
                // encuentra y estatus es cero la quite
                // Usar el estado anterior para evitar problemas de actualización 
                return DtoDocuments.map((elemento) =>
                        elemento.intCusDocId === objeto.intCusDocId? 
                            { ...elemento,  
                                strCusDocLastModifiedBy :objeto.strCusDocLastModifiedBy, 
                                strCusDocLastModifiedBy:objeto.strCusDocLastModifiedBy, 
                                strStatus:objeto.strStatus,
                                strReason:objeto.strReason
                            }
                            : elemento
                    ); 
                });  
        }*/
        
    }

    if(!ValidaItemMenu("reference-pool")){
        CerrarSesion();
        return;
    }
 
    const ConsultarDocumentosUsuario = async(mostrar_cortinilla=true) => {
        try { 
            if(mostrar_cortinilla){
                setIsLoading(true); 
            }
            setDtoDocuments();
                const url = URL+GETREFERENCESBYUSER; 
                const params = {
                    "intUserId":getUserID()
                }  
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
                 if(resultado.code === 0){  
                    if(resultado.rows.length > 0){
                        setDtoDocuments(resultado.rows);
                    }else{
                        Mensaje("No se encontraron reeferencias asociadas a este usuario.","info","top-center",4500);
                    }
                    setIsLoading(false);
                }else{
                    if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                      //
                      if(resultado.status === 404){
                        Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                      }else if(resultado === "Failed to fetch"){
                        Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                      }
                    } 
                    setIsLoading(false);
                  }
                /*else if(resultado.code > 0){ 
                    Mensaje(resultado.msg, "error","top-center",3500); 
                    setIsLoading(false); 
                }else if(resultado.code < 0){ 
                    Mensaje(resultado.msg, "error","top-center",3500); 
                    setIsLoading(false); 
                } */
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        }
    }

    const handleBuscar = (text)=>{
        setValidaBuscar('is-valid');
        setBuscar(text);
        if (grid) {
            grid.search(text);
        }
    }
    
    const handleBtnBuscar = (text)=>{
        if (grid) {
            grid.search(text);
        }
    }

    const AgregarNuevaReferencia = () =>{
        setModo('A');
        setReferenciaId(0);
        OpenSubirDocumento();
    };
      
    let grid;
 
    const ColumnControls = (props) => {
        return (           
                parseInt(getUserEntityIsEmployee()) === 1? 
                <> 
                    {props.strCusDocAsigTo === getUserName().trim() ?
                        <span className="rowControls">
                            <button  id={"consultar"+props.intCusDocId} 
                                className={`consultar${props.intCusDocId} btn btn-opcion p-0 m-0`} 
                                title="VALIDAR DOCUMENTO PDF"  
                                onClick={()=>{Accion_Consultar(
                                    props.intCusDocId,
                                    props.strStatus,

                                    props.strCusDocInvDockName,
                                    props.strCusDocInvPBIPName,
                                    props.strVesselName,
                                    props.strCusDocEntityName,//solicitado_por

                                    props.strCusDocReference,
                                    props.strDocumentTypeDescription,
                                    props.imgDocumentImageFile
                                    ,0)}} >
                                <Iconos icono={"VALIDAR_PDF"}  width={"20"} height={"20"} fill="#0f6d41" />
                            </button></span>
                            :<></>}
                        

                        {/* props.strStatus === "ON-VALID"?
                            <button className="btn text-bg-success py-1 m-1" onClick={ ()=>{CerrarProceso(props.intCusDocId)} }  > <span className="fw-normal">CERRAR PROCESO</span> </button>
                            :<></>
                        */}
                    
                </>
                :<span className="rowControls">
                    <button id={"consultar"+props.intCusDocId} className={`consultar${props.intCusDocId} btn btn-opcion p-0 m-0`} title="CONSULTAR DOCUMENTO"  
                        onClick={()=>{
                            Accion_Consultar(
                                props.intCusDocId,
                                props.strStatus,

                                props.strCusDocInvDockName,
                                props.strCusDocInvPBIPName,
                                props.strVesselName,
                                props.strCusDocEntityName,//solicitado_por

                                props.strCusDocReference,
                                props.strDocumentTypeDescription,
                                props.imgDocumentImageFile,
                                1
                            )
                        }
                    } >
                        <Iconos icono={"CONSULTAR"}  width={"20"} height={"20"} fill="#0f6d41" />
                    </button>
                    {props.strStatus !== "ON-VALID" && props.strStatus !== "TER" && props.strStatus !== "CAP"?
                        <button id={"editar"+props.id}    className={`editar${props.id} btn btn-opcion p-0 m-0`}    title="EDITAR DOCUMENTO"     
                            onClick={()=>{Accion_Editar(props.intCusDocId, props.strCusDocReference,)}} >
                        <Iconos  icono={"EDITAR"}  width={"20"} height={"20"} fill="#091975"/>
                    </button>:<></>
                    }
                    {props.strStatus !== "ON-VALID" && props.strStatus !=="TER"?
                    <button id={"eliminar"+props.intCusDocId}  className={`eliminar_${props.intCusDocId} btn btn-opcion p-0 m-0`} title="ELIMINAR DOCUMENTO"   
                        onClick={()=>{
                            Accion_Eliminar(
                                props.intCusDocId,
                                props.strStatus,
                                props.strCusDocReference,
                                props.strDocumentTypeDescription)}}>
                        <Iconos  icono={"ELIMINAR"}  width={"20"} height={"20"} fill="#ad2323" />
                    </button>:<></>
                    }
                    
                </span>  
        ) 
    }

    const ColumnStatus = (props) => {
        return (     
            <label className="fw-bold">
                {
                    props.strStatus === "CAP"?
                    <span className="text-primary"> 
                    <Iconos icono={props.strStatus}  width={"25"} height={"25"}  fill="#0d6efd" />
                    <span className="px-2">CAPTURADO</span>
                    </span>:
                    props.strStatus === "ON-VALID"? 
                        <span className="text-warning"> 
                            <Iconos icono={props.strStatus}  width={"25"} height={"25"} fill="#ffb936"/>
                            <span className="px-2">EN VALIDACIÓN</span>
                        </span>:
                        props.strStatus === "REJ"?
                            <span className="text-danger" title={props.strReason}>
                                <Iconos icono={props.strStatus}  width={"25"} height={"25"} fill="#dc3545"/>
                                <span className="px-2">{props.strReason}</span>
                            </span>:
                                    props.strStatus === "TER"?
                                    <span className="text-success"> 
                                        <Iconos icono={"CERRADO"}  width={"25"} height={"25"} fill="#198754"/>
                                        <span className="px-2">TERMINADO</span>
                                    </span>:
                                        props.strStatus === "CAN"?
                                        <span className="text-black"> 
                                            <Iconos icono={"CANCELADO"}  width={"25"} height={"25"} fill="#000"/>
                                            <span className="px-2">CANCELADO</span>
                                        </span>:<></>
                }
            </label>    
            
        ) 
    }

    const ColumnDate = (props) => {
        const date = new Date(props.dtmCusDocLastModified);
        const pad = (num) => {return (num < 10 ? '0' : '') + num};
        let formattedDate = "";
        if( date.getUTCFullYear() === 1900 ){
          formattedDate = "-";
        }else{
          formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())} ${pad(date.getHours()>=12? "PM":"AM")}`;  
        }
        return formattedDate; 
    }

    const rowControls = ColumnControls;
    const rowStatus = ColumnStatus;
    const Celldate = ColumnDate;
    
    const Accion_Consultar= async(id,estatus,muellaje, pbip,buque, solicitado_por, Strreferencia,descripcion,imgDocumentImageFile,intmode)=>{
        try { 
        setReferenciaId(id);
        setEstatus(estatus);
        setStrReferencia(Strreferencia);
        setStrDocumentTypeDescription(descripcion);
        setPdfData(imgDocumentImageFile);
        setIntMode(intmode);
        
        setPbip(pbip);
        setMuellaje(muellaje);
        setBuque(buque)
        setSolicitadoPor(solicitado_por);
        /*
            setIsLoading(true); 
                //const url = URL+GETDOCUMENTBYID; 
                const url = URL+GETREFERENCEBYID;//GETDOCUMENTBYID; 
                const params = {
                    "intUserId":getUserID(),
                    "intCusDocId": id
                    //"referenciaid": id
                }  
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
              
                if(resultado.code === 0){ 
                    //setPdfData(resultado.rows[0].imgDocumentImageFile);
                    setPdfData(resultado.docs);
                    setIsLoading(false);
                }else{
                    setPdfData("");
                    Mensaje(resultado.msg, "info"); 
                    setIsLoading(false); 
                } 
        }*/
        OpenMostrarPfd();
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        }
    }

    const Accion_Editar=(referenciaid,strCusDocReference)=>{
        setModo('E');
        setReferenciaId(referenciaid);
        setStrReferencia(strCusDocReference);
        OpenSubirDocumento(); 
    }

    const Accion_Eliminar=(referenciaid,strStatus, referencia, strDocumentTypeDescription)=>{
        setReferenciaId(referenciaid);
        setEstatus(strStatus);
        setReferencia(referencia);
        setStrDocumentTypeDescription(strDocumentTypeDescription);
        OpenEliminar();
    }
    
    const ordenarPorColumna = (array, columna, valor) => {
        const sortByColumn = (a, b) => {
          if (a[columna] === valor && b[columna] !== valor) {
            return -1;
          } else if (a[columna] !== valor && b[columna] === valor) {
            return 1;
          } else {
            return a[columna].localeCompare(b[columna]);
        }
    };
   
        return array.sort(sortByColumn);
    }
  
    const OrdenarPorStrstatus = (value) => {
        // Crear un nuevo array ordenado sin mutar el original
        const resultadoOrdenado = ordenarPorColumna([...dtodocuments], 'strStatus', value);
        setDtoDocuments(resultadoOrdenado);
    }
    
    const rowDataBound = (args) => {
        if (args.row) {   //{props.strCusDocAsigTo === getUserName().trim() ?
            if ( getValue('strCusDocAsigTo', args.data)  === getUserName().trim()) {
                args.row.classList.add('asignado');
                //args.row.classList.add('bg-primary');
            } 
            else {
                //args.row.classList.add('bg-danger');
                args.row.classList.add('bg-white');
            }
        }
    }

    return(
        <div className="main">
            <Menu /> 
            {isLoading?<Loader />:<></>} 
            <ToastContainer style={{width:'500px'}}/>
            <Dash>
                <p className="h5" >POOL DE REFERENCIAS</p>
                    <hr className="m-0" />
                        <div id="pool_documents" className="" >
                                {/*<p className="h5 m-0 p-0">POOL REFERENCIAS</p>
                                <hr className="m-1 p-0"/>*/}
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                        <div className="input-group input-group-sm p-0 m-1">
                                            <input type="text" className={`form-control ${validabuscar}`} value={buscar} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={(evt)=>{handleBuscar(evt.target.value)}} />
                                            <span className="input-group-text btn btn-secondary" id="inputGroup-sizing-sm" >
                                                <Iconos icono={"BUSCAR"}  width={"25"} height={"25"} fill="#fff"/>
                                            </span>
                                        </div>
                                    </div>   
                                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 m-1">
                                        {ValidaItemMenu("up-reference") && ValidaIsModal("up-reference") && ( parseInt(getUserEntityIsEmployee()) === 0)?
                                        <button className=" bg-green btn text-white fw-bold w-100 p-1" title={"AGREGAR NUEVO REFERENCIA"} onClick={AgregarNuevaReferencia}>
                                            <Iconos icono={"AGREGAR"}  width={"25"} height={"25"} fill="#fff"/>
                                            AGREGAR REFERENCIA
                                        </button>:<></>
                                        }
                                    </div> 
                                </div> 

                                <div className="row  py-2 "> 
                                    <button className="btn bg-info    text-white fw-bold col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" onClick={()=>{handleBtnBuscar('')} } > VER TODO  </button>
                                    <button className="btn bg-primary text-white fw-bold col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" onClick={()=>{handleBtnBuscar('CAP')}  }  > CAPTURADO </button>
                                    <button className="btn bg-danger  text-white fw-bold col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" onClick={()=>{handleBtnBuscar('REJ')}  } > RECHAZADO </button>
                                    <button className="btn bg-warning text-white fw-bold col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" onClick={()=>{handleBtnBuscar('ON-VALID')}} > VALIDADO  </button>
                                    <button className="btn bg-success text-white fw-bold col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" onClick={()=>{handleBtnBuscar('TER')}  } > TERMINADO </button>
                                    
                                    <button className=" btn text-bg-secondary fw-bold    col-lg-2 col-md-2 col-sm-2 col-xs-6 p-0 m-0" title={"ACTUALIZAR LISTADO"} onClick={ConsultarDocumentosUsuario}> 
                                        <Iconos icono={"RELOAD"} width={"25"} height={"30"} fill="#FFF"/>
                                            ACTUALIZAR LISTADO 
                                    </button>
                                    {/*<button className="btn bg-black   text-white fw-bold col-lg-2 col-md-2 col-sm-6 col-xs-6" onClick={()=>{handleBtnBuscar('CAN')}  } > CANCELADO </button>*/}
                                </div>

                                {/*<div className="row m-0 p-0">
                                    <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 p-0 m-0">
                                        <button className=" btn bg-secondary text-white fw-bold  p-0 m-0" title={"ACTUALIZAR LISTADO"} onClick={ConsultarDocumentosUsuario}>
                                            <label className={"p-0 m-0 "}><Iconos icono={"RELOAD"} width={"25"} height={"30"} fill="#FFF"/>ACTUALIZAR LISTADO</label>
                                        </button>
                                    </div>   
                                </div> */}
                                { dtodocuments?       
                                    < >   
                                        <div className="" style={{ overflow:"scroll"}}>
                                        <GridComponent  
                                            dataSource={dtodocuments} 
                                            locale="es-ES"
                                            ref={g => grid = g}
                                            dataStateChange={dtodocuments} 
                                            allowPaging={true} 
                                            allowResizing={true} 
                                            rowHeight={30} 
                                            height='auto' 
                                            allowFiltering={false}  
                                            allowSorting = {true} 
                                            pageSettings={{pageSize:15, pageCount:15,  pageSizes: true }} 
                                            rowDataBound={rowDataBound} >
                                            <ColumnsDirective > 
                                            <ColumnDirective field={'intCusDocId'}   template={rowControls} width='25' headerText="ACCIONES" textAlign="center"/> 
                                            {/*<ColumnDirective field={'intCusDocId'}   Type={"ColumnType.Integer"} width='15' headerText="ID" textAlign="left"/>*/}
                                                <ColumnDirective field={'strCusDocReference'}   Type={"ColumnType.Integer"} width='40' headerText="REFERENCIA" textAlign="left"/>
                                                {<ColumnDirective field={'intQuantityDocs'}   Type={"ColumnType.Integer"} width='15' headerText="DOCUMENTOS" textAlign="left"/>}
                                                
                                                <ColumnDirective field={'strStatus'} template={rowStatus} width='45' headerText="ESTATUS" textAlign="left"/> 
                                                
                                                <ColumnDirective field={'strCusDocEntityName'}   Type={"ColumnType.String"} width='45' headerText="SOLICITADO POR" textAlign="left"/>

                                                <ColumnDirective field={'strCusDocInvPBIPName'}   Type={"ColumnType.String"} width='45' headerText="FAC. PBIP" textAlign="left"/>
                                                <ColumnDirective field={'strCusDocInvDockName'}   Type={"ColumnType.String"} width='45' headerText="FAC. MUELLAJE" textAlign="left"/>
                                                <ColumnDirective field={'strVesselName'}   Type={"ColumnType.String"} width='45' headerText="BUQUE" textAlign="left"/>
                                                
                                                
                                                <ColumnDirective field={'dtmCusDocLastModified'}   template={Celldate} Type={"ColumnType.String"} width='60' headerText="FECHA MODIFICACIÓN" textAlign="left"/>
                                                <ColumnDirective field={'strCusDocLastModifiedBy'} Type={"ColumnType.String"} width='40' headerText="USUARIO MODIFICO" textAlign="left" />
                                            </ColumnsDirective>  
                                            <Inject services={[Page,Filter,Sort,Resize ]} />
                                        </GridComponent>
                                        </div>
                                    </>
                                    :<></>
                                } 
                                { isOpenEliminar &&
                                    <div id="modal-resultados-validacion">
                                        <Modal titulo={"ELIMINAR REFERENCIA"} isOpen={isOpenEliminar} closeModal={closeEliminar} Width={'50vw'}   >
                                            <EliminarDocumento
                                                URL={URL}
                                                SAVEUPDATEDOCUMENT={SAVEUPDATEDOCUMENT}
                                                referenciaid={referenciaid}
                                                estatus={estatus}
                                                referencia={referencia}
                                                strDocumentTypeDescription = {strDocumentTypeDescription  }
                                                ConsultarDocumentosUsuario={ConsultarDocumentosUsuario}
                                                Mensaje={Mensaje}
                                                setIsLoading={ setIsLoading }
                                                isOpenEliminar={isOpenEliminar} 
                                                OpenEliminar={OpenEliminar} 
                                                closeEliminar={closeEliminar}/>
                                        </Modal>
                                    </div>
                                }
                                { isOpenSubirDocumento && 
                                    <div id="modal-resultados-validacion">  
                                        <Modal titulo={ modo === 'E'? "EDITAR REFERENCIA":"CREAR REFERENCIA" } isOpen={isOpenSubirDocumento} closeModal={closeSubir} Height={'auto'}  Width={'80vw'} agrgandodocumento={agrgandodocumento} >
                                        
                                            <UploadFile 
                                                referenciaid={referenciaid}
                                                setReferenciaId={setReferenciaId}
                                                strreferencia={strreferencia}
                                                tabIndex={tabIndex}

                                                agrgandodocumento={agrgandodocumento}
                                                setAgregandoDocumentos={setAgregandoDocumentos}

                                                setTabIndex={setTabIndex}
                                                ConsultarDocumentosUsuario={ ConsultarDocumentosUsuario }
                                                modo={modo}
                                                setModo={setModo}
                                                Mensaje={Mensaje}
                                                setIsLoading={ setIsLoading }
                                                isOpenSubirDocumento={isOpenSubirDocumento}  
                                                OpenSubirDocumento={OpenSubirDocumento}  
                                                closeModal={closeSubir}
                                            />
                                            
                                        </Modal>
                                    </div>
                                }

                                { isOpenMostrarPfd &&
                                    <div id="modal-resultados-validacion">
                                        <Modal titulo={`MOSTRAR REFERENCIA: ${strreferencia} `} isOpen={isOpenMostrarPfd}  closeModal={closeMostrarPfd}  Height={'95%'} Width={'85%'} >
                                            <MostrarPdf 
                                                referenciaid={referenciaid}
                                                estatus={estatus}
                                                setEstatus={setEstatus}
                                                strreferencia={referencia}
                                                intmode={intmode}
                                                strDocumentTypeDescription = {strDocumentTypeDescription}
                                                
                                                muellaje={muellaje}
                                                pbip={pbip}
                                                buque={buque}
                                                solicitado_por={solicitado_por}
                                                Mensaje={Mensaje}
                                                ConsultarDocumentosUsuario={ConsultarDocumentosUsuario}
                                                pdfData={pdfData}
                                                mimetype={"application/pdf"}
                                                setIsLoading={ setIsLoading }
                                                isOpenMostrarPdf={isOpenMostrarPfd}
                                                OpenMostrarPdf={OpenMostrarPfd}  
                                                closeMostrarPdf={closeMostrarPfd}

                                                OpenRechazarPdf={OpenRechazarPdf}
                                            />
                                        </Modal>
                                    </div>
                                }

                                { isOpenRechazarPdf &&
                                    <div id="modal-resultados-validacion">
                                        <Modal titulo={"RECHAZAR REFERENCIA"} isOpen={isOpenRechazarPdf}  closeModal={closeRechazarPdf} Width={'80%'}  >
                                            <ModalRechazarPdf   
                                                intCusDocId={referenciaid}
                                                estatus={estatus}  
                                                strreferencia = {strreferencia} 
                                                intmode={intmode} 
                                                ConsultarDocumentosUsuario={ConsultarDocumentosUsuario}
                                                Mensaje={Mensaje}
                                                setIsLoading={ setIsLoading }
                                                txtbtnconfirmar="CONFIRMAR RECHAZAR" 
                                                mensaje="ESTA SEGURO DE RECHAZAR"
                                                closeRechazarPdf={closeRechazarPdf}
                                                closeMostrarPdf={closeMostrarPfd}
                                            />
                                        </Modal>
                                    </div>
                                }  
                        </div>        
            </Dash>
        </div>
    );
}

const  EliminarDocumento=({URL, referenciaid, estatus, referencia, strDocumentTypeDescription, ConsultarDocumentosUsuario,Mensaje, setIsLoading, isOpenEliminar, OpenEliminar, closeEliminar})=>{
    
    const EliminarDocumento = async(referenciaid,estatus) => {
        try { 

            if(estatus === "ON-VALID"){
                Mensaje("No es posible eliminar este documento","warning","top-center",4000);
                closeEliminar();
                return; 
            }

            if(referenciaid > 0){
                setIsLoading(true);
                const url = URL + SAVEUPDATEREFERENCE;
                const params = {   
                    "strUserName": getUserName(), 
                    "intMode":3,
                    "ref":{
                        "intCusDocId": referenciaid
                    }
                }
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
              
                if(resultado.code === 0){
                    Mensaje(resultado.msg,"success","top-center",4000);    
                    closeEliminar();
                    ConsultarDocumentosUsuario();
                }else{
                    Mensaje(resultado.msg,"error","top-center",6500);
                    setIsLoading(false);
                }
                /*
                   if(resultado.code === 0){
                        if(resultado.ref.code === 0){ 
                            Mensaje(resultado.ref.msg,"success","top-center",4000);    
                        }else{
                            Mensaje(resultado.ref.msg,"error","top-center",4000);    
                        }
                        closeEliminar();
                        ConsultarDocumentosUsuario();
                        
                    }else{
                        Mensaje(resultado.msg,"error","top-center",6500);
                        setIsLoading(false);
                    }
                */
                
            }else{   
                Mensaje("No hay un documento asignado.","error","top-center",6500);
            }    
        }catch (error){
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud - Eliminar()","error","top-center");
        } 
    } 
    return(
        <>              
        <div className="modal-body"> 
            <div className="">
                <p className="fw-bold">¿ESTA SEGURO QUE DESEA ELIMINAR EL DOCUMENTO CON REFERENCIA: {referencia}?</p>
            </div>
        </div>
        <div className="modal-footer">
            <div className="row">
                <div>
                    <button className="btn bg-danger text-white fw-bold float-end mx-1" onClick={()=>{EliminarDocumento(referenciaid,estatus)}}>ELIMINAR DOCUMENTO</button>
                    <button className="btn bg-primary text-white fw-bold float-end mx-1" onClick={closeEliminar}>CANCELAR</button>
                </div>
            </div>    
        </div>    
        </>
    )
} 

export default PoolReferencias;